import React, { useContext } from "react";
import {
  Box,
  ClickAwayListener,
  IconButton,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { blue, orange } from "@mui/material/colors";
import SummaryDashboard from "../summary_components/SummaryDashboard";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import autoSummaryDataLOCAL from "../data/simulation_summary_auto_final.json";
import fireSummaryDataLOCAL from "../data/simulation_summary_fire_final.json";
import { ResultsContext } from "../ResultsContext";

// const API_RESULTS_BASE_URL =
//   "https://zqhmgl85wh.execute-api.us-east-1.amazonaws.com/simulation/results";

const SummaryPage = () => {
  const { numAutoClaims, numFireClaims } = useContext(ResultsContext);
  const totalNumClaims = 900;

  // These are for the Info Icon Button in Header
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleInfoClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoClose = () => {
    setAnchorEl(null);
  };

  const InfoOpen = Boolean(anchorEl);
  //--------------------------------------------
  return (
    <Box sx={{ p: 2 }}>
      <Stack
        sx={{
          borderRadius: 5,
          border: 5,
          borderColor: "lightgray",
          // fontSize: 20,

          justifyContent: "center",
          display: "flex",
         
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={"center"}
          spacing={1}
          sx={{ pt:0.5, justifyContent: "center", backgroundColor: "lightgray" }}
        >
          <Typography
            align="center"
            sx={{
              color: "secondary.main",
              border: 0,
              pt: 0,
              // pl: 55,
              fontSize: 26,
              fontWeight: "bold",
              // width: "100%",
            }}
          >
            Simulation Summary
          </Typography>
          <IconButton
            size="small"
            onClick={handleInfoClick}
            aria-label="Information"
            sx={{ color: "secondary.main" }}
          >
            <InfoOutlinedIcon />
          </IconButton>
        </Stack>
        <Popover
          open={InfoOpen}
          anchorEl={anchorEl}
          onClose={handleInfoClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{ sx: { p: 2, maxWidth: 300 } }}
        >
          <ClickAwayListener onClickAway={handleInfoClose}>
            <Stack direction="row" alignItems="start" spacing={1}>
              <IconButton size="small" onClick={handleInfoClose}>
                <CloseIcon fontSize="medium" />
              </IconButton>
              <Typography variant="body1" sx={{ flex: 1 }}>
                {/* Your info message goes here */}
                The simulation was ran on 900 Auto/Fire Claims. {
                  numAutoClaims
                }{" "}
                Auto Claims and {numFireClaims} Fire Claims had Similar
                Comparisons which are shown in this UI.
              </Typography>
            </Stack>
          </ClickAwayListener>
        </Popover>
        <Stack
          sx={{
            pb: 2,
            backgroundColor: "lightgray",
            justifyContent: "center",
            display: "flex",
            borderBottom: 3,
            borderColor: "secondary.main",
          }}
          direction={"row"}
          spacing={1}
        >
          <Typography
            // align="center"
            sx={{
              color: blue[900],
              fontSize: 24,
              fontWeight: "bold",
              // width: "100%",
            }}
          >
            {totalNumClaims} Auto Claims
          </Typography>
          <Typography
            align="left"
            sx={{
              color: "secondary.main",
              fontSize: 24,
              fontWeight: "bold",
            }}
          >
            {"\u2022"}
          </Typography>
          <Typography
            align="left"
            sx={{
              color: orange[900],
              fontSize: 24,
              fontWeight: "bold",
              // width: "100%",
            }}
          >
            {totalNumClaims} Fire Claims
          </Typography>
        </Stack>
        <SummaryDashboard
          autoSummary={autoSummaryDataLOCAL}
          fireSummary={fireSummaryDataLOCAL}
          totalNumClaims={totalNumClaims}
        />
      </Stack>
    </Box>
  );
};

export default SummaryPage;
